// extracted by mini-css-extract-plugin
export var centerText = "_dc-8";
export var container = "_dc-0";
export var doughnutContainer = "_dc-7";
export var legend = "_dc-a";
export var legendItemColorDisplay = "_dc-b";
export var legendItemLabel = "_dc-d";
export var legendItemValue = "_dc-c";
export var lg = "_dc-5";
export var maxWidth = "_dc-9";
export var md = "_dc-4";
export var responsive = "_dc-6";
export var sm = "_dc-3";
export var xs = "_dc-2";
export var xxs = "_dc-1";